import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';

type ChatContextType = {
  isChatOpen: boolean;
  setIsChatOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ChatContext = createContext<ChatContextType>(null!);

export const ChatProvider: React.FC = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <ChatContext.Provider
      // value={{ isChatWindowOpen, setIsChatWindowOpen, connect, hasUnreadMessages, messages, conversation }}
      value={{ isChatOpen, setIsChatOpen }}
    >
      {children}
    </ChatContext.Provider>
  );
};
